<script setup lang="ts">
import {DetectionErrorProps} from "@/notification/interfaces";

defineProps<{
    error: DetectionErrorProps;
}>();
</script>

<template>
  <div class="flex group text-sm items-center gap-2">
    <p class="text-gray-600 leading-relaxed">
      {{ error.message }}
    </p>
    <p
      v-if="error.code"
      class="text-xs text-gray-400 invisible group-hover:visible"
    >
      {{ error.code }}
    </p>
  </div>
</template>
